import {
  generateToken,
  validateAndGetToken,
} from "../BridgeServices";

/**
 * @desc    The handler for the fetch token callback received from the native layer.
 *
 * @param error
 * @param response
 * @param context
 * @param data
 */
export const FetchTokenBridge = (
  error,
  response,
  context,
  data
) => {
  //1. If there is an error while fetch token, handle it gracefully
  if (error) {
    console.log(error);
    return;
  }

  //2. Fetch the value of key from the callback data
  var tokenValue = data.value;

  //3. Check existence and expiry of token, then set it in token variable. If it fails, call generateToken
  var validToken = validateAndGetToken(tokenValue);
  if (validToken) {
    window.token = validToken;
  } else {
    generateToken();
  }
};
